'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NoSpaceBetweenColumns = undefined;

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoSpaceBetweenColumns = function NoSpaceBetweenColumns(refs) {
    var i18n = refs.i18nManager.get();

    return Ext.create('Ext.form.field.Checkbox', {
        boxLabel: i18n.no_space_between_columns,
        style: 'margin-bottom:' + _Style2.default.checkboxBottomMargin + 'px'
    });
};

exports.NoSpaceBetweenColumns = NoSpaceBetweenColumns;
exports.default = NoSpaceBetweenColumns;
//# sourceMappingURL=NoSpaceBetweenColumns.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/NoSpaceBetweenColumns.js
 ** module id = 356
 ** module chunks = 0
 **/